var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStrategyAndFinanceIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 77 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M38.496 12.59a1.582 1.582 0 1 0 0-3.164 1.582 1.582 0 0 0 0 3.164ZM10.114 62.452a1.582 1.582 0 1 0 0-3.165 1.582 1.582 0 0 0 0 3.165ZM66.895 62.452a1.582 1.582 0 1 0 0-3.165 1.582 1.582 0 0 0 0 3.165ZM33.945 66.49v12.455M43.055 66.49v12.455",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.76 2.005 1.27 63.473c-.771 1.34.195 3.017 1.738 3.017h70.977c1.551 0 2.518-1.676 1.738-3.017L40.236 2.005c-.772-1.34-2.712-1.34-3.484 0h.008Z",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.037 43.363 35.32 32.63c-.133-2.089-.203-3.593-.203-4.505 0-1.24.328-2.206.975-2.9.646-.694 1.504-1.044 2.564-1.044 1.286 0 2.143.444 2.58 1.332.436.89.647 2.167.647 3.843 0 .99-.055 1.988-.156 3.001L40.76 43.41c-.1 1.317-.327 2.323-.67 3.024-.343.702-.912 1.052-1.707 1.052s-1.364-.343-1.684-1.02c-.32-.679-.537-1.716-.67-3.103h.008Zm2.486 14.747a3.51 3.51 0 0 1-2.385-.888c-.678-.593-1.02-1.419-1.02-2.48 0-.927.327-1.714.974-2.36.646-.648 1.441-.975 2.385-.975.943 0 1.746.327 2.408.974a3.18 3.18 0 0 1 .998 2.362c0 1.044-.335 1.87-1.006 2.463a3.454 3.454 0 0 1-2.354.896v.008Z",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgStrategyAndFinanceIcon;